import { css } from '@emotion/react';
import React from 'react';

import { useAriaTitle } from '~src/commons/utils/hooks/a11y-hooks';
import { useTranslations } from '~src/commons/utils/translations/translate';

import { HorizontalLogoDeck } from '../../commons/components/logo-deck-row/horizontal-logo-deck';
import { useGlobalState } from '../../global-state';
import { Button } from '../../ui/button';
import { AddressProvider } from './address-provider';

/*
 * This feature is a form on an incentive for the user to input the address to
 * show possible local delivery options. We only display it pre-address and in
 * conjuction with global delivery options already shown.
 *
 * From technical view it is just a different form of address input/modal.
 *
 * This component was called "UpfrontCarriers" in the old widget, but I find
 * "UpfrontAddress" more suitable, because it's more related to address than to
 * carriers.
 */
export const UpfrontAddressButton: React.FC = () => {
  const { tICU } = useTranslations();
  const globalState = useGlobalState();
  // TODO: check this one
  const session = globalState.sessions[0];

  useAriaTitle(tICU('widget.aria.CHECKOUT_ADDRESS_FORM.TITLE'), 'checkout');

  return (
    <AddressProvider>
      {({ onOpen }) => (
        <div css={styles.wrapper}>
          <Button buttonType="secondary" css={styles.button} onClick={onOpen}>
            {tICU('widget.UPFRONT_CARRIERS_BUTTON')}
          </Button>
          <HorizontalLogoDeck carrierLogos={session.upfront_carriers!} />
        </div>
      )}
    </AddressProvider>
  );
};

const styles = {
  wrapper: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }),
  button: css({
    marginBottom: '14px',
  }),
};
